import * as Sentry from '@sentry/react'
import { browserTracingIntegration } from '@sentry/react'

const { VITE_SENTRY_ENVIRONMENT: SENTRY_ENVIRONMENT } = import.meta.env

export const setupSentry = (): void => {
    console.log('Setting up Sentry...', {
        dsn: 'https://d16d3d25ac134d689de5f495aa03c372@o793342.ingest.sentry.io/5801370',
        environment: SENTRY_ENVIRONMENT
    });

    Sentry.init({
        dsn: 'https://d16d3d25ac134d689de5f495aa03c372@o793342.ingest.sentry.io/5801370',
        integrations: [browserTracingIntegration()],
        environment: SENTRY_ENVIRONMENT || 'development',

        // Enable automatic error capturing
        autoSessionTracking: true,
        attachStacktrace: true,

        // Add beforeSend to debug what's being sent
        beforeSend(event) {
            console.log('Sentry beforeSend:', event);
            return event;
        },

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,

        // Enable debug mode in development
        debug: import.meta.env.DEV,

        // Enable session replay
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });

    console.log('Sentry initialized successfully');

    // Set up global error handlers for unhandled exceptions
    window.addEventListener('error', (event) => {
        console.log('Global error handler caught:', event.error);
        Sentry.captureException(event.error);
    });

    window.addEventListener('unhandledrejection', (event) => {
        console.log('Global unhandled rejection handler caught:', event.reason);
        Sentry.captureException(event.reason);
    });
}
